import React from 'react';
import { Building2, Users, FileSearch, TrendingUp, Flag, Heart, Gift, Workflow, Brain, UserPlus, Map, Database } from 'lucide-react';
import { RadialOrbitalTimeline } from './RadialOrbitalTimeline';
const timelineData = [{
  id: 1,
  title: 'Professional Management',
  date: '2024',
  content: 'We have the skillset and mindset of thoughtfully adapting big company practices to family businesses.',
  category: 'Management',
  icon: Building2,
  relatedIds: [2, 3],
  status: 'completed' as const,
  energy: 100
}, {
  id: 2,
  title: 'Succession & Exit Planning',
  date: '2024',
  content: 'We help strategize, coordinate, discover, and groom the right successors.',
  category: 'Planning',
  icon: Workflow,
  relatedIds: [1, 3],
  status: 'completed' as const,
  energy: 90
}, {
  id: 3,
  title: 'Staff Support & Culture Care',
  date: '2024',
  content: 'Family-oriented approach of supporting personnel outside of work, promoting growth in the workplace, and community engagement. This promotes longevity of our staff and results in low turnover.',
  category: 'Culture',
  icon: Heart,
  relatedIds: [1, 2],
  status: 'completed' as const,
  energy: 95
}, {
  id: 4,
  title: 'Systems & Technology',
  date: '2024',
  content: 'Our consolidated resources, software, processes, and systems will be applied to all locations and promote an efficient and effective operational platform built for scale.',
  category: 'Operations',
  icon: Brain,
  relatedIds: [5, 8],
  status: 'completed' as const,
  energy: 85
}, {
  id: 5,
  title: 'Stewardship & Giving',
  date: '2024',
  content: 'We allocate a portion of our annual profits and personal time to give back to the community, non-profits, and strategic partners. We also include our employees and allow them to participate directly with organizations they support.',
  category: 'Community',
  icon: Gift,
  relatedIds: [3, 4],
  status: 'completed' as const,
  energy: 90
}, {
  id: 6,
  title: 'Referral & Patient Growth',
  date: '2024',
  content: 'We drive patient growth by acting on a referral within 3 hours, instead of the industry standard of 48. We also leverage strategic performance metrics which help maximize our time, effectiveness, success rates, and the quality of industry partnerships.',
  category: 'Growth',
  icon: UserPlus,
  relatedIds: [7, 8],
  status: 'in-progress' as const,
  energy: 80
}, {
  id: 7,
  title: 'Regionalization',
  date: '2024',
  content: 'We will have multiple locations within each strategic region to maximize economies of scale and capture additional market share.',
  category: 'Growth',
  icon: Map,
  relatedIds: [6, 8],
  status: 'in-progress' as const,
  energy: 75
}, {
  id: 8,
  title: 'Data Management',
  date: '2024',
  content: 'We train our clinical staff to document accordingly, and when coupled with our operational metrics, we increase efficiencies while also generating a market value for our data.',
  category: 'Operations',
  icon: Database,
  relatedIds: [4, 6, 7],
  status: 'in-progress' as const,
  energy: 70
}];
export function DifferentiatorsTimeline() {
  return <RadialOrbitalTimeline timelineData={timelineData} data-id="element-60" />;
}